import {
  DndContextProps,
  DndContext as DndKitContext,
  KeyboardSensor,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';

import { sortableKeyboardCoordinates } from '@dnd-kit/sortable';
import { FC, PropsWithChildren } from 'react';

type TProps = {
  sortable?: boolean;
  hasKeyboardSensor?: boolean;
} & DndContextProps;

const DndContext: FC<PropsWithChildren<TProps>> = (props) => {
  const {
    children,
    sortable = false,
    hasKeyboardSensor = true,
    ...rest
  } = props;

  const sensors = useSensors(
    // useSensor(PointerSensor) is not used as it's a combination of MouseSensor and TouchSensor
    // and we want to use both separately to control different activation constraints
    useSensor(MouseSensor, {
      // Require the mouse to move by 10 pixels before activating
      // (if not set the onClick handle is intercepted and never triggered)
      activationConstraint: {
        distance: 10,
      },
    }),
    useSensor(TouchSensor, {
      // Press delay of 250ms, with tolerance of 5px of movement
      // (if not set the onClick handle is intercepted and never triggered)
      activationConstraint: {
        delay: 250,
        tolerance: 5,
      },
    }),
    hasKeyboardSensor
      ? useSensor(
          KeyboardSensor,
          sortable
            ? {
                coordinateGetter: sortableKeyboardCoordinates,
              }
            : undefined
        )
      : null
  );

  return (
    <DndKitContext sensors={sensors} {...rest}>
      {children}
    </DndKitContext>
  );
};

export default DndContext;
